// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IMatchEmployeeAggregatorDto } from './IMatchEmployeeAggregatorDto';
import {
    IMatchEmployeeAggregatorDtoFromJSON,
    IMatchEmployeeAggregatorDtoFromJSONTyped,
    IMatchEmployeeAggregatorDtoToJSON,
    IMatchEmployeeAggregatorDtoToJSONTyped,
} from './IMatchEmployeeAggregatorDto';

/**
 * 
 * @export
 * @interface IEmployeeMatchDetailsAggregatorDto
 */
export interface IEmployeeMatchDetailsAggregatorDto {
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeMatchDetailsAggregatorDto
     */
    is_too_many?: boolean;
    /**
     * 
     * @type {Array<IMatchEmployeeAggregatorDto>}
     * @memberof IEmployeeMatchDetailsAggregatorDto
     */
    matched_employees?: Array<IMatchEmployeeAggregatorDto>;
}

/**
 * Check if a given object implements the IEmployeeMatchDetailsAggregatorDto interface.
 */
export function instanceOfIEmployeeMatchDetailsAggregatorDto(value: object): value is IEmployeeMatchDetailsAggregatorDto {
    return true;
}

export function IEmployeeMatchDetailsAggregatorDtoFromJSON(json: any): IEmployeeMatchDetailsAggregatorDto {
    return IEmployeeMatchDetailsAggregatorDtoFromJSONTyped(json, false);
}

export function IEmployeeMatchDetailsAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeMatchDetailsAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_too_many': json['is_too_many'] == null ? undefined : json['is_too_many'],
        'matched_employees': json['matched_employees'] == null ? undefined : ((json['matched_employees'] as Array<any>).map(IMatchEmployeeAggregatorDtoFromJSON)),
    };
}

export function IEmployeeMatchDetailsAggregatorDtoToJSON(json: any): IEmployeeMatchDetailsAggregatorDto {
    return IEmployeeMatchDetailsAggregatorDtoToJSONTyped(json, false);
}

export function IEmployeeMatchDetailsAggregatorDtoToJSONTyped(value?: IEmployeeMatchDetailsAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_too_many': value['is_too_many'],
        'matched_employees': value['matched_employees'] == null ? undefined : ((value['matched_employees'] as Array<any>).map(IMatchEmployeeAggregatorDtoToJSON)),
    };
}

